import React from "react";
import profile1 from "@public/img/profiles/1.png";
import profile2 from "@public/img/profiles/2.png";
import profile3 from "@public/img/profiles/3.png";
import profile4 from "@public/img/profiles/4.png";
import profile5 from "@public/img/profiles/5.png";
import profile6 from "@public/img/profiles/6.png";
import profile7 from "@public/img/profiles/7.png";
import profile8 from "@public/img/profiles/8.png";
import profile9 from "@public/img/profiles/9.png";
import profile10 from "@public/img/profiles/10.png";
import profile11 from "@public/img/profiles/11.png";
import profile12 from "@public/img/profiles/12.png";
import profile13 from "@public/img/profiles/13.png";
import profile14 from "@public/img/profiles/14.png";
import profile15 from "@public/img/profiles/15.png";
import profile16 from "@public/img/profiles/16.png";
import profile17 from "@public/img/profiles/17.png";
import profile18 from "@public/img/profiles/18.png";
import profile19 from "@public/img/profiles/19.png";
import profile20 from "@public/img/profiles/20.png";
import profile21 from "@public/img/profiles/21.png";
import profile22 from "@public/img/profiles/22.png";
import profile23 from "@public/img/profiles/23.png";
import profile24 from "@public/img/profiles/24.png";
import profile25 from "@public/img/profiles/25.png";
import profile26 from "@public/img/profiles/26.png";
import profile27 from "@public/img/profiles/27.png";
import profile28 from "@public/img/profiles/28.png";
import profile29 from "@public/img/profiles/29.png";
import profile30 from "@public/img/profiles/30.png";
import profile31 from "@public/img/profiles/31.png";
import profile32 from "@public/img/profiles/32.png";
import profile33 from "@public/img/profiles/33.png";
import profile34 from "@public/img/profiles/34.png";
import profile35 from "@public/img/profiles/35.png";
import profile36 from "@public/img/profiles/36.png";
import profile37 from "@public/img/profiles/37.png";
import profile38 from "@public/img/profiles/38.png";
import profile39 from "@public/img/profiles/39.png";
import profile40 from "@public/img/profiles/40.png";
import profile41 from "@public/img/profiles/41.png";
import profile42 from "@public/img/profiles/42.png";
import profile43 from "@public/img/profiles/43.png";
import profile44 from "@public/img/profiles/44.png";
import profile45 from "@public/img/profiles/45.png";

export const PROFILE_AVATAR_IDS = Array.from({ length: 45 }, (_, i) => String(i + 1));

export const Avatars = [
    profile1,
    profile2,
    profile3,
    profile4,
    profile5,
    profile6,
    profile7,
    profile8,
    profile9,
    profile10,
    profile11,
    profile12,
    profile13,
    profile14,
    profile15,
    profile16,
    profile17,
    profile18,
    profile19,
    profile20,
    profile21,
    profile22,
    profile23,
    profile24,
    profile25,
    profile26,
    profile27,
    profile28,
    profile29,
    profile30,
    profile31,
    profile32,
    profile33,
    profile34,
    profile35,
    profile36,
    profile37,
    profile38,
    profile39,
    profile40,
    profile41,
    profile42,
    profile43,
    profile44,
    profile45,
];

export const getAvatar = (avatar: string) => {
    switch (avatar) {
        case "1": return profile1;
        case "2": return profile2;
        case "3": return profile3;
        case "4": return profile4;
        case "5": return profile5;
        case "6": return profile6;
        case "7": return profile7;
        case "8": return profile8;
        case "9": return profile9;
        case "10": return profile10;
        case "11": return profile11;
        case "12": return profile12;
        case "13": return profile13;
        case "14": return profile14;
        case "15": return profile15;
        case "16": return profile16;
        case "17": return profile17;
        case "18": return profile18;
        case "19": return profile19;
        case "20": return profile20;
        case "21": return profile21;
        case "22": return profile22;
        case "23": return profile23;
        case "24": return profile24;
        case "25": return profile25;
        case "26": return profile26;
        case "27": return profile27;
        case "28": return profile28;
        case "29": return profile29;
        case "30": return profile30;
        case "31": return profile31;
        case "32": return profile32;
        case "33": return profile33;
        case "34": return profile34;
        case "35": return profile35;
        case "36": return profile36;
        case "37": return profile37;
        case "38": return profile38;
        case "39": return profile39;
        case "40": return profile40;
        case "41": return profile41;
        case "42": return profile42;
        case "43": return profile43;
        case "44": return profile44;
        case "45": return profile45;
    }
}

export default function AvatarWidget({ avatar, className = "", size = 100, onClick }: { avatar: number, className?: string, size?: number, onClick?: () => void }) {
    return (
        <img src={getAvatar(avatar.toString()) ?? ""} alt="avatar" className={`object-cover rounded-full ${className}`} onClick={onClick} />
    );
}